import { render } from "./RememberPass.vue?vue&type=template&id=c28ef650&scoped=true"
import script from "./RememberPass.vue?vue&type=script&lang=js"
export * from "./RememberPass.vue?vue&type=script&lang=js"

import "./custom-activate.scss?vue&type=style&index=0&id=c28ef650&lang=scss&scoped=true"
import "./RememberPass.vue?vue&type=style&index=1&id=c28ef650&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28ef650"]])

export default __exports__